import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {User} from '../_model/user';
import {LoginRequest} from '../_model/login.request';
import {BaseService} from './base.service';
import {LoginResponse} from '../_model/response/login.response';
import {ApiResponse} from '../_model/ApiResponse';
import {ForgetPasswordRequest} from '../_model/forgetpassword.request';
import {PasswordUpdateRequest} from '../_model/request/PasswordUpdateRequest';
import {RenewPasswordRequest} from '../_model/request/RenewPasswordRequest';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends BaseService {
  public currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private http: HttpClient) {
    super(http);
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public assignCurrentUser(currentUserData: LoginResponse){
    this.currentUserSubject.next(currentUserData);
  }

  login(loginRequest: LoginRequest) {
    return this.post<any>('/auth/login', loginRequest)
      .pipe(map(user => {
      // TODO role seciminden sonra alttaki kodlar yer alacak
      // localStorage.setItem('currentUser', JSON.stringify(user.responseData.item));
      // this.currentUserSubject.next(user.responseData.item);
      return user;
    }));
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('lookupList');
    this.currentUserSubject.next(null);
  }

  sendPasswordResetMail(forgetPasswordRequest: ForgetPasswordRequest) {
    return this.post<ApiResponse>('/auth/sendresetmail', forgetPasswordRequest);
  }

  isPasswordResetTokenValid(token: string) {
    return this.get<ApiResponse>('/auth/password/tokenvalid/' + token);
  }

  updatePassword(passwordUpdateRequest: PasswordUpdateRequest) {
    return this.post<ApiResponse>('/auth/password/update', passwordUpdateRequest);
  }

  renewPassword(request: RenewPasswordRequest) {
    return this.post<ApiResponse>('/auth/password/renew', request);
  }
}
